/**
 *
 * This file needs to be manually kept in sync with contracts
 * -- along with its declaration file
 * -- and types/index.ts
 *
 */
module.exports = {
    AUCTION_CONTRACT_NAME: 'FirstDibsAuction',
    AUCTION_V2_CONTRACT_NAME: 'FirstDibsAuctionV2',
    TOKEN_CONTRACT_NAME: 'FirstDibsToken',
    GENERIC_TOKEN_CONTRACT_NAME: 'GenericERC721Token',
    GENERIC_1155_TOKEN_CONTRACT_NAME: 'GenericERC1155Token',
    TOKEN_V2_CONTRACT_NAME: 'FirstDibsTokenV2',
    REGISTRY_CONTRACT_NAME: 'FirstDibsCreatorRegistry',
    MARKET_SETTINGS_CONTRACT_NAME: 'FirstDibsMarketSettings',
    MARKET_SETTINGS_V2_CONTRACT_NAME: 'FirstDibsMarketSettingsV2',
    TOKEN_V1_ROYALTY_OVERRIDE_NAME: 'FirstDibsTokenV1RoyaltyOverride',
    BALANCE_CONTRACT_NAME: 'FirstDibsBalances',
    SPLIT_MAIN_NAME: 'SplitMain',
    ROYALTY_REGISTRY: 'RoyaltyRegistry',
    ROYALTY_ENGINE_V1: 'RoyaltyEngineV1',
    FIRST_DIBS_MARKET_V3: 'FirstDibsMarketV3',
    FIRST_DIBS_FEE_SUPPORT: 'FirstDibsFeeSupport',
    FIRST_DIBS_TOKEN_TRANSFER_MANAGER: 'FirstDibsTokenTransferManager',
};
